export const siteInfo = {
  name: '番号大全',
  tagline: '最全番号查询与分类索引',
  description: '番号大全收录海量番号信息，提供按类型、演员、厂牌等多维度分类检索服务。无论你是初次接触还是资深用户，番号大全帮你快速找到所需内容，索引完整、更新及时、查询便捷。',
  url: 'https://fanhao.example.com',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类浏览', href: '/category/all' },
  { label: '文章资讯', href: '/article/guide-intro' },
  { label: '关于我们', href: '/about' },
];

export const categories = [
  {
    id: 'type',
    name: '按类型',
    icon: 'ri-stack-line',
    description: '企划、单体、剧情、素人等多种类型分类',
    slug: 'type',
    subCategories: [
      { name: '企划', slug: 'planned', count: 2840 },
      { name: '单体', slug: 'solo', count: 1956 },
      { name: '剧情', slug: 'story', count: 1632 },
      { name: '素人', slug: 'amateur', count: 3120 },
      { name: '合集', slug: 'compilation', count: 890 },
      { name: 'VR', slug: 'vr', count: 456 },
    ],
  },
  {
    id: 'actress',
    name: '按演员',
    icon: 'ri-user-star-line',
    description: '收录人气演员完整番号作品列表',
    slug: 'actress',
    subCategories: [
      { name: '三上悠亜', slug: 'yua-mikami', count: 128 },
      { name: '河北彩花', slug: 'saika-kawakita', count: 86 },
      { name: '相沢みなみ', slug: 'minami-aizawa', count: 95 },
      { name: '楓カレン', slug: 'karen-kaede', count: 72 },
      { name: '山手梨愛', slug: 'ria-yamate', count: 54 },
      { name: '石川澪', slug: 'mio-ishikawa', count: 48 },
    ],
  },
  {
    id: 'label',
    name: '按厂牌',
    icon: 'ri-building-line',
    description: '知名厂牌番号完整索引列表',
    slug: 'label',
    subCategories: [
      { name: 'S1 NO.1 STYLE', slug: 's1', count: 3200 },
      { name: 'Moodyz', slug: 'moodyz', count: 2800 },
      { name: 'Idea Pocket', slug: 'ideapocket', count: 2400 },
      { name: 'Prestige', slug: 'prestige', count: 2100 },
      { name: 'SOD Create', slug: 'sod', count: 1800 },
      { name: 'FALENO', slug: 'faleno', count: 900 },
    ],
  },
  {
    id: 'series',
    name: '按系列',
    icon: 'ri-play-list-line',
    description: '经典系列作品完整收录',
    slug: 'series',
    subCategories: [
      { name: 'SSIS系列', slug: 'ssis', count: 450 },
      { name: 'IPX系列', slug: 'ipx', count: 380 },
      { name: 'MIDE系列', slug: 'mide', count: 320 },
      { name: 'ABP系列', slug: 'abp', count: 290 },
      { name: 'STARS系列', slug: 'stars', count: 260 },
      { name: 'FSDSS系列', slug: 'fsdss', count: 180 },
    ],
  },
];

export const hotItems = [
  {
    id: 'h1',
    code: 'SSIS-888',
    title: '完全主観×絶対領域 制服美少女の秘密の放課後',
    actress: '河北彩花',
    label: 'S1 NO.1 STYLE',
    genre: '制服',
    releaseDate: '2025-12-15',
    rating: 4.8,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20poster%20design%20with%20soft%20amber%20and%20coral%20gradients%20over%20a%20subtle%20grid%20pattern%2C%20clean%20editorial%20aesthetic%20with%20Japanese%20wabisabi%20influence%2C%20textured%20paper%20background%20with%20delicate%20geometric%20accents%2C%20warm%20nature-inspired%20color%20palette%2C%20refined%20and%20elegant%20composition&width=400&height=560&seq=fh-hot-01&orientation=portrait',
  },
  {
    id: 'h2',
    code: 'IPX-998',
    title: '絶世の美少女と二人きりの空間 濃密な時間',
    actress: '相沢みなみ',
    label: 'Idea Pocket',
    genre: '美少女',
    releaseDate: '2025-12-08',
    rating: 4.7,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20poster%20with%20soft%20warm%20terracotta%20and%20cream%20gradients%2C%20clean%20editorial%20layout%20with%20Japanese%20design%20influence%2C%20textured%20rice%20paper%20background%20with%20delicate%20abstract%20shapes%2C%20harmonious%20warm%20tone%20palette%2C%20refined%20aesthetic%20composition&width=400&height=560&seq=fh-hot-02&orientation=portrait',
  },
  {
    id: 'h3',
    code: 'MIDV-777',
    title: '新人NO.1STYLE 奇跡の美少女AVデビュー',
    actress: '石川澪',
    label: 'Moodyz',
    genre: '新人',
    releaseDate: '2025-11-28',
    rating: 4.6,
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20modern%20poster%20design%20with%20soft%20peach%20and%20cream%20gradients%2C%20clean%20editorial%20aesthetic%20with%20subtle%20Japanese%20motifs%2C%20textured%20washi%20paper%20background%2C%20warm%20earth%20tone%20palette%20with%20delicate%20geometric%20elements%2C%20elegant%20harmonious%20composition&width=400&height=560&seq=fh-hot-03&orientation=portrait',
  },
  {
    id: 'h4',
    code: 'FSDSS-666',
    title: '芸能人の秘密のオフショット 禁断のプライベート',
    actress: '楓カレン',
    label: 'FALENO',
    genre: '芸能人',
    releaseDate: '2025-11-20',
    rating: 4.5,
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20poster%20design%20with%20warm%20cinnamon%20and%20cream%20gradients%2C%20clean%20editorial%20style%20with%20Japanese%20minimalist%20aesthetic%2C%20textured%20handmade%20paper%20background%20with%20delicate%20abstract%20patterns%2C%20refined%20warm%20tone%20palette%2C%20elegant%20balanced%20composition&width=400&height=560&seq=fh-hot-04&orientation=portrait',
  },
  {
    id: 'h5',
    code: 'STARS-900',
    title: '絶頂開発 敏感体質美少女の限界突破',
    actress: '山手梨愛',
    label: 'SOD Create',
    genre: '美少女',
    releaseDate: '2025-12-01',
    rating: 4.6,
    image: 'https://readdy.ai/api/search-image?query=Refined%20minimalist%20poster%20design%20with%20soft%20sand%20and%20coral%20gradients%2C%20editorial%20aesthetic%20with%20Japanese%20design%20influence%2C%20textured%20natural%20fiber%20paper%20background%2C%20warm%20harmonious%20color%20palette%20with%20subtle%20abstract%20elements%2C%20elegant%20composition&width=400&height=560&seq=fh-hot-05&orientation=portrait',
  },
  {
    id: 'h6',
    code: 'SSIS-777',
    title: '交わる体液、濃密セックス 完全ノーカット',
    actress: '三上悠亜',
    label: 'S1 NO.1 STYLE',
    genre: '単体',
    releaseDate: '2025-11-15',
    rating: 4.9,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20poster%20with%20warm%20amber%20and%20cream%20gradients%2C%20refined%20editorial%20layout%20with%20subtle%20Japanese%20aesthetic%20elements%2C%20textured%20artisan%20paper%20background%20with%20delicate%20geometric%20lines%2C%20harmonious%20earth%20tone%20composition%2C%20sophisticated%20design&width=400&height=560&seq=fh-hot-06&orientation=portrait',
  },
];

export const latestUpdates = [
  { id: 'l1', code: 'SSIS-901', title: '新任女教師 禁断の放課後レッスン', date: '2025-12-18', genre: '女教師' },
  { id: 'l2', code: 'IPX-1001', title: '絶頂覚醒 開発された美少女のカラダ', date: '2025-12-17', genre: '美少女' },
  { id: 'l3', code: 'MIDV-801', title: '彼女の親友に誘惑されて…禁断の関係', date: '2025-12-16', genre: 'ドラマ' },
  { id: 'l4', code: 'ABP-998', title: '天然美少女のプライベートSEX', date: '2025-12-15', genre: '美少女' },
  { id: 'l5', code: 'FSDSS-701', title: '芸能人 本気のセックス解禁', date: '2025-12-14', genre: '芸能人' },
  { id: 'l6', code: 'STARS-888', title: '極上ボディの超接写フェティッシュ', date: '2025-12-13', genre: 'フェチ' },
  { id: 'l7', code: 'CAWD-555', title: '清楚系美少女の恥じらい初体験', date: '2025-12-12', genre: '新人' },
  { id: 'l8', code: 'JUQ-444', title: '人妻秘書、汗と接吻に満ちた業務時間', date: '2025-12-11', genre: '人妻' },
  { id: 'l9', code: 'ROE-333', title: '義母と二人だけの秘密の週末', date: '2025-12-10', genre: '義母' },
  { id: 'l10', code: 'DLDSS-222', title: '超ハイスペック美少女の濃厚ご奉仕', date: '2025-12-09', genre: '美少女' },
];

export const faqs = [
  {
    question: '番号大全是什么？',
    answer: '番号大全是专注于番号信息收录与分类检索的专业平台，提供按类型、演员、厂牌、系列等多维度的番号查询服务。收录海量番号信息，索引完整、更新及时，帮助用户快速找到所需番号的详细信息。',
  },
  {
    question: '如何按演员搜索番号？',
    answer: '在首页点击「按演员」分类入口，进入演员番号列表页面。我们收录了众多人气演员的完整作品番号，按演员名称字母排序，支持快速查找。也可以通过顶部搜索框直接输入演员名称进行检索。',
  },
  {
    question: '番号代码的含义是什么？',
    answer: '番号代码通常由厂牌缩写和数字编号组成。例如「SSIS-888」中，SSIS代表S1 NO.1 STYLE厂牌的系列编号，888为该作品的序列号。不同厂牌有各自独特的番号命名规则，番号大全提供了完整的厂牌番号对照说明。',
  },
  {
    question: '网站收录的番号信息更新频率如何？',
    answer: '番号大全保持每日更新，同步收录最新发布的番号信息。每月新增番号条目超过500条，确保用户能够获取到最新、最全的番号资讯。',
  },
  {
    question: '番号大全是否收费？',
    answer: '番号大全完全免费使用。所有番号查询、分类浏览、信息检索功能均不收取任何费用。我们致力于为番号爱好者提供一个便捷、全面的信息查询平台。',
  },
  {
    question: '如何反馈缺失或错误的番号信息？',
    answer: '如果您发现任何番号信息缺失或存在错误，欢迎通过关于我们页面的联系表单向我们反馈。我们的编辑团队会在24小时内核实并更新相关信息，确保番号大全的数据准确性。',
  },
];

export const stats = [
  { label: '收录番号', value: '52,800+', icon: 'ri-database-2-line' },
  { label: '收录演员', value: '3,200+', icon: 'ri-user-star-line' },
  { label: '收录厂牌', value: '180+', icon: 'ri-building-line' },
  { label: '每日更新', value: '50+', icon: 'ri-refresh-line' },
];